/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Period_StartInputs */

const en_settings_billing_period_start = /** @type {(inputs: Settings_Billing_Period_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period start`)
};

/**
* | output |
* | --- |
* | "Period start" |
*
* @param {Settings_Billing_Period_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_period_start = /** @type {((inputs?: Settings_Billing_Period_StartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Period_StartInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_period_start(inputs)
});
export { settings_billing_period_start as "settings.billing.period_start" }